<template>
<div>
	
	<div class="uk-container-expand productScreen">
			<appNav></appNav>
	</div>


	<div class="uk-container">
	
		<hr class="uk-divider-icon">

<div id="item"></div>

<div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin" uk-grid>
    <div class="uk-card-media-left uk-cover-container">
        <img :src="item.bigPic" alt="" uk-cover>
        <canvas width="600" height="400"></canvas>
    </div>
    <div>
        <div class="uk-card-body">
            <span class="uk-label ">{{ item.sort }}</span>
            <h3 class="uk-card-title">{{ item.name }}</h3>
            <p>{{ item.descr }}</p>
						<div class="uk-h6">Срок годности <b> {{ item.srok }} </b></div>
        </div>
				<div class="uk-card-footer">
							<a href="#"  @click.prevent="toHome" class="uk-button uk-button-text goHome">На главную</a>
							<a href="#" @click.prevent="toCatalog" class="uk-button uk-button-text goHome">В каталог</a>
							<a href="#" @click.prevent="whereBuy" class="whereBuy uk-button uk-button-text">Где купить <i class="mdi mdi-cart-outline"></i></a>
					</div>
    </div>
</div>






	<hr class="uk-divider-icon">

	<div class="uk-h3">Похожие</div>

		<div class="CardFirstProducts uk-child-width-1-5@l uk-child-width-1-4@m uk-child-width-1-3@s uk-child-width-1-2 uk-grid-small" uk-grid	>
    <div v-for="bread in getBreads" :key="bread.id">
        <div  class="uk-card uk-card-hover uk-card-default"  >
					
					<router-link tag="a"  :to="'/product/' + bread.id" class="uk-link-reset">
					<a @click="scro" href="#item" >
            <div class="uk-card-media-top">
                <img :src="bread.picSrc" alt="">
            </div>
            <div class="uk-card-body uk-card-small">
                <p>{{ bread.name }}</p>
								<div class="uk-visible@s uk-label">{{ bread.sort }}</div>
            </div>
						</a>
					</router-link>

        </div>
				</div>
		</div>



		<br>
		<br>
		<br>
		<br>
		<br>

	</div>
	</div>
</template>



<script>
import appNav from '@/components/Nav'
/* eslint-disable no-console */
 /* eslint-disable no-alert */

// import UIkit from 'uikit'


export default {
	props: ['id'],
	data () {
		return {
			ms: 'Карточка продукта'
		}
	},
	computed: {
		item () {
			let id = this.id
			return this.$store.getters.breadById(id)
		},
		getBreads (){
			return this.$store.getters.getBreads
		}
	},

	methods: {
		scro () {
			console.log('scrol')
			setTimeout(() => {
			window.scrollTo({ top: 100, behavior: 'smooth' });
			},500)

		},
		toHome () {
			this.$router.push('/')
		},
		toCatalog() {
			this.$router.push('/products')
		},
		whereBuy() {
			this.$router.push('/shops')
		}
	},

	created() {
			window.scrollTo(0, 0);
		},

	components: {
		appNav
	}
}
</script>


<style>
/* @import url(/uikit/css/uikit.min.css); */

.productScreen .uk-navbar-container:not(.uk-navbar-transparent) {
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 0%, #ecf0f1 150.79%);
}

.productScreen .uk-navbar-nav>li>a {
	font-weight: 500;
}

.goHome{
	margin-right: 25px;
}

.whereBuy{
	color:#DE1F24;
	font-weight: 500;
}

</style>